<template>
  <div class="mobile_index">
    <myHeader :isDark="false" />
    <!-- 设计即实现部分 -->
    <div class="design_implement">
<!--      <p>WHERE DESIGN BCOMONE REALITY</p>-->
      <P>DESIGN BECOMES REALITY</P>
      <!-- <img src="https://download.hecoos.com/enlightv/2025-20/79900826f556177de74c526a12aa93ed.png" alt=""> -->
    </div>
    <!-- 视频部分 -->
    <div class="video">
      <video style="width: 100%" autoplay muted loop playsinline webkit-playsinline x5-playsinline
        x-webkit-airplay="allow"
        poster="https://download.hecoos.com/enlightv/2025-37/1e148a3d54641a6a75703a1922f8c229.mp4?x-oss-process=video/snapshot,t_1000,m_fast"
        src="https://download.hecoos.com/enlightv/2025-37/1e148a3d54641a6a75703a1922f8c229.mp4"></video>
      <!-- <img style="width: 375px; height: 179px;" src="@/asset/mobile/index/video.png" alt=""> -->
    </div>

    <!-- hecoos Studio部分 -->
    <div class="hecoos_studio">
      <p style="
          color: #706e73;
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 5px;
        " class="hecoos_studio_p">
        hecoos Studio
      </p>
      <p style="
          color: #fff;
          font-weight: 700;
          font-size: 26px;
          margin-bottom: 20px;
        " class="hecoos_studio_p1">
        Seamless Design to Execution
      </p>

      <div class="hecoos_studio_content">
        <div class="hecoos_studio_content_left">
          <p @click="jumpTo('/en/studio')" class="p_active">3D PREVISUALIZATION</p>
          <p @click="jumpTo('/en/studio')" class="p_active">PROJECTION SIMULATION</p>
          <p @click="jumpTo('/en/studio')" class="p_active">LIGHTING PROGRAMMING</p>
          <p @click="jumpTo('/en/studio')" class="p_active">BROADCAST CONTROL</p>
          <p @click="jumpTo('/en/studio')" class="p_active">LIVE CONTROL</p>
        </div>

        <div class="hecoos_btn">
          <button @click="handleClickStudioLink()">Free Trial</button>
          <button @click="jumpTo('/en/studio')">Learn More</button>
        </div>
        <!-- <div class="hecoos_studio_content_right">
          <div class="hecoos_img">
            <img style="width: 90%" src="@/asset/index/hecoosImg.png" alt="" />
          </div>
          <p>
            hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障。
          </p>

          <div class="hecoos_btn">
            <button @click="jumpTo('/1')">开启免费体验</button>
            <button @click="jumpTo('/2')">了解更多</button>
          </div>
        </div> -->
      </div>
    </div>

    <!-- hecoos xR / VP部分 -->
    <div class="hecoos_xr_vp">
      <p style="
          color: #24272a;
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 10px;
        " class="hecoos_studio_p">
        hecoos xR / VP
      </p>
      <p style="
          color: #24272a;
          font-weight: 700;
          font-size: 26px;
          letter-spacing: 1px;
          margin-bottom: 35px;
        " class="hecoos_studio_p1">
        Creating Boundless Visions between <br>
        Reality and Imagination
      </p>
      <img width="100%" style="border-radius: 15px"
        src="https://download.hecoos.com/enlightv/2025-17/b47a0de71e01928151e04092b491d177.gif" alt="" />
      <button @click="jumpTo('/en/virtualProduction')">Learn More</button>
    </div>

    <!-- hecoos Server部分 -->
    <div class="hecoos_server">
      <p style="
          color: #fff;
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 10px;
        " class="hecoos_studio_p">
        hecoos Server
      </p>
      <p class="Server_title">
        The Core of Live Control and Virtual Production
      </p>
      <!-- <img
        width="100%"
        src="@/asset/mobile/index/hecoos_server_Img.png"
        alt=""
      /> -->
      <video autoplay muted ref="hecoosVideo" width="100%" playsinline webkit-playsinline x5-playsinline
        x-webkit-airplay="allow"
        src="https://download.hecoos.com/enlightv/2025-10/5041d9a4efe8822b28ec28af02b8213f.mp4"></video>
      <div class="hecoos_content">
        <p class="hecoos_content_title">Explore our hardware</p>
        <div class="hecoos_content_item">
          <div class="hecoos_content_item_left">
            <p class="hecoos_content_item_title1">Server-D</p>
            <p class="text1">
              Full Control from Creative Concept to Seamless Performance
            </p>
          </div>
          <button @click="jumpTo('/en/mediaServer?section=0#tab')">learn more</button>
        </div>

        <div class="hecoos_content_item">
          <div class="hecoos_content_item_left">
            <p class="hecoos_content_item_title2">Server-C</p>
            <p class="text1">
              Key Hub in the Virtual Production Filming Process
            </p>
          </div>
          <button @click="jumpTo('/en/mediaServer?section=1#tab')">learn more</button>
        </div>

        <div class="hecoos_content_item" style="border-bottom: none">
          <div class="hecoos_content_item_left">
            <p class="hecoos_content_item_title3">Server-R</p>
            <p class="text1">
              Powerful Rendering Capabilities Empower Virtual Content Creators
            </p>
          </div>
          <button @click="jumpTo('/en/mediaServer?section=2#tab')">learn more</button>
        </div>
      </div>
    </div>

    <!-- 视频教程部分 -->
    <div class="video_course">
      <div class="video_course_wenB">
        <p style="color: #fff; font-size: 26px; font-weight: 700" class="video_course_wenB_p">
          Video Tutorials
        </p>
        <p style="
            margin-top: 8px;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.64);
            font-weight: 300;
          ">
          Explore Online Videos Created by Experts
Our Latest Updates
        </p>
      </div>
      <div class="video_course_img">
        <img src="@/asset/mobile/index/video_course.png" alt="" />
        <p class="video_title">Embrace A New Workflow</p>
        <div class="play" @click="jumpTo('/en/video_tutorial')">
          <div class="play_icon">
          </div>
          <!-- <img src="@/asset/mobile/index/btn.png" alt="" /> -->
        </div>
      </div>
      <div style="width: 100%; height: 40px"></div>
    </div>

    <!-- Elfsight LinkedIn Feed | Untitled LinkedIn Feed -->
    <div class="linkedIn_wrap">
      <div class="linkedin_title">Linkedin</div>
      <div class="linkedin_title2">Follow hecoos Linkedln for the latest news!</div>
      <div class="elfsight-app-aece7f42-505e-45e8-af53-928e56e90364" data-elfsight-app-lazy></div>
    </div>

    <!-- 案例展示部分 -->
    <div class="case_show">
      <p style="color: #fff; font-size: 26px; font-weight: 700">Showcases</p>
      <p style="
          margin-top: 8px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.64);
          font-weight: 300;
          margin-bottom: 20px;
        " class="case_show_p">
        Our Latest Updates
      </p>
      <van-swipe :autoplay="3000" :height="160" :loop="false" :show-indicators="false">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="showVideo(item.link)"
          class="van_swipe_item">
          <img width="100%" :src="item.cover" alt="">
          <p>{{ item.title }}</p>
        </van-swipe-item>
      </van-swipe>
      <button class="case_show_btn" @click="jumpTo('/en/casepresentation')">
        View All Cases
      </button>
    </div>

    <!-- <myListen /> -->
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import myListen from "@/components/en_mobile/myListen.vue";
import videoPlayback from "@/components/en_mobile/videoPlayback.vue";
import { getCaseList } from "@/api/api";
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
  data() {
    return {
      // baseUrl: 'https://www.hecoos.com/',
      bannerList: [],
      showVideoPlayer: false,
      videoUrl: 'https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4',
    };
  },
  created() {
    this.getCaseLists();
  },
  mounted() {
    // 处理微信环境下视频自动播放
    if (
      typeof WeixinJSBridge === "object" &&
      typeof WeixinJSBridge.invoke === "function"
    ) {
      WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
        const video1 = document.getElementById("video1");
        const video2 = document.getElementById("video2");
        if (video1) video1.play();
        if (video2) video2.play();
      });
    } else {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          const video1 = document.getElementById("video1");
          const video2 = document.getElementById("video2");
          if (video1) video1.play();
          if (video2) video2.play();
        },
        false
      );
    }
    const video = this.$refs.hecoosVideo;
    const options = {
      root: null,
      rootMargin: "0px",
      // 当视频显示一半时触发回调
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.currentTime = 0; // 重置视频播放进度
          video.play().catch((error) => {
            console.log("视频播放失败:", error);
          });
        } else {
          video.pause(); // 视频离开视口时暂停
        }
      });
    }, options);

    this.observer.observe(video);

    video.addEventListener("ended", () => {
      video.pause(); // 视频播放结束后定格
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    const video = this.$refs.hecoosVideo;
    video.removeEventListener("ended", () => {
      video.pause();
    });
  },
  components: {
    myHeader,
    myFooter,
    myListen,
    videoPlayback,
  },
  computed: {
    ...mapState(["adminUserInfo"]),
  },
  methods: {
    handleClickStudioLink(){
      if(this.adminUserInfo && this.adminUserInfo.id){
        this.jumpTo('/en/personalCenter')
      }else{
        this.jumpTo('/en/Register')
      }
    },
    jumpTo(path) {
      this.$router.push(path)
    },
    // 显示视频播放器
    showVideo(url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
    getCaseLists() {
      let postData = {
        page: 1,
        limit: 8,
        type: '101'
      };
      getCaseList(postData).then((res) => {
        if (res.code === 200) {
          this.bannerList = res.data;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_mobile/mobile_xty.scss";
</style>
